import { sendTransactions } from '@multiversx/sdk-dapp/services/transactions/sendTransactions';
import { refreshAccount } from '@multiversx/sdk-dapp/utils/account/refreshAccount';
import { environment , vestingContract} from '../config';
import { AbiRegistry, Address, SmartContract, TokenTransfer, Transaction } from '@multiversx/sdk-core/out';
import json from '../contracts/user-reward-vesting.abi.json';
import { signMessage } from '@multiversx/sdk-dapp/utils/account';

// Smart contract address - should be in config for different environments
const CONTRACT_ADDRESS = vestingContract;

// Initialize ABI and smart contract
const abi = AbiRegistry.create(json);
export const smartContract = new SmartContract({
    address: new Address(CONTRACT_ADDRESS),
    abi,
});

export const buildRedeemTransaction = (nft: { collection: string, nonce: number }, senderAddress: string) => {
    console.log('Building redeem transaction for NFT:', nft);
    
    // Build transaction using ABI
    const transaction = smartContract.methodsExplicit
        .claimReward()
        .withSender(Address.fromBech32(senderAddress))
        .withSingleESDTNFTTransfer(
            TokenTransfer.semiFungible(nft.collection, nft.nonce, 1)
        )
        .withGasLimit(10000000)  // Based on actual gas used
        .withChainID(environment === 'devnet' ? 'D' : '1')
        .buildTransaction()
        .toPlainObject();

    console.log('Built transaction:', transaction);

    return transaction;
};

export const sendRedeemTransaction = async (nft: { collection: string, nonce: number }, senderAddress: string) => {
    try {
        const transaction = buildRedeemTransaction(nft, senderAddress);
        console.log('Attempting to send transaction:', transaction);

        // Send transaction using MultiversX SDK
        const { sessionId, error } = await sendTransactions({
            transactions: [transaction], // Must be an array
            transactionsDisplayInfo: {
                processingMessage: 'Processing redeem transaction',
                errorMessage: 'An error occurred during redemption',
                successMessage: 'NFT redeemed successfully'
            },
            redirectAfterSign: false,
            minGasLimit: 4200000
        });

        if (error) {
            console.error('Transaction error:', error);
            throw new Error(error);
        }

        console.log('Transaction sent successfully, sessionId:', sessionId);

        // Refresh account to update balance
        await refreshAccount();

        return { sessionId };
    } catch (error) {
        console.error('Error details:', {
            name: error.name,
            message: error.message,
            stack: error.stack,
        });
        throw error;
    }
};
